<div id="mySvgContainer" class="w-full h-fit overflow-auto">
    <div class="svgContainer" #svgContainer></div>
</div>
